import type { QueryClient } from "@tanstack/react-query";
import type { FormMetadataParams } from "@/entities/form-metadata";
import { getMetadataQueryOptions } from "@/entities/form-metadata";
import { userPreferencesQueryOptions } from "@/entities/user-preferences";
import { useEffectOnce } from "@/shared/hooks/useEffectOnce";
import { pageContextQueryOptions } from "@/shared/page-context";

interface PrefetchContext {
    formMetadataParams: FormMetadataParams;
}

export const usePrefetchQueries = (queryClient: QueryClient, context: PrefetchContext) => {
    const { formMetadataParams } = context;

    useEffectOnce(() => {
        void queryClient.ensureQueryData(pageContextQueryOptions);
        void queryClient.prefetchQuery(userPreferencesQueryOptions());
        void queryClient.prefetchQuery(getMetadataQueryOptions(formMetadataParams));
    });
};
